import { clone } from 'test-utils/clone';
import { removeEmpty } from 'utils/remove-empty';

const buildData = (_, { body } = {}) => {
  if (!body) {
    return undefined;
  }

  if (body instanceof FormData) {
    return body;
  }

  return removeEmpty(clone(body));
};

export default buildData;
